import React from "react";
import "../../../CssFiles/benefitsAndProcess.css";
import benefit1 from "../../../Images/benefitImages/benefit1.png";
import benefit2 from "../../../Images/benefitImages/benefit2.png";
import benefit3 from "../../../Images/benefitImages/benefit3.png";
import fast_approval_banner from "../../../Images/benefitImages/fast_approval_banner_desktop-min.png";
import fast_approval_banner_msite from "../../../Images/benefitImages/fast_approval_banner_msite.png";

export default function BenefitsComponent() {
  return (
    <div id="benefit-box">
      {/* <div className="beneText">BENEFITS</div>     */}
      <div className="yourLine">
        Your <span className="trusted">Trusted</span> Loan Marketplace
      </div>
      <div className="tailorApp">
        Our tailored approach, reliable lenders, and seamless process ensure you
        get the best loan options for your business.
      </div>

      <div id="imageBenefit" className="imageBenefit">
        <div className="imageBox col-4">
          <img src={benefit1} alt="benefit1" className="boxImg" style={{borderRadius:'8px'}}/>
          <div className="headingTextBox">
            <div className="boxHeading">Smart Loan Matching</div>
            <div className="boxText">
              We match you with lenders likely to approve your loan, using our
              expertise in their criteria.
            </div>
          </div>
        </div>
        <div className="imageBox col-4">
          <img src={benefit2} alt="benefit1" className="boxImg" />
          <div className="headingTextBox">
            <div className="boxHeading">Always on Your Side</div>
            <div className="boxText">
              We advocate for your financial needs, ensuring you get the loan
              you need, not just what works for lenders.
            </div>
          </div>
        </div>
        <div className="imageBox col-4">
          <img src={benefit3} alt="benefit1" className="boxImg" />
          <div className="headingTextBox">
            <div className="boxHeading">Offers from Partner Lenders</div>
            <div className="boxText">
              We work with partner lenders to provide tailored loan offers that
              increase your approval chances and meet your needs.
            </div>
          </div>
        </div>
      </div>

      <div>
        <>
          <img
            src={fast_approval_banner}
            alt="fast-approval-banner"
            className="fastBanner desktopBanner"
          />
          <img
            src={fast_approval_banner_msite}
            alt="fast-approval-banner"
            className="fastBanner mobileBanner"
          />
        </>
      </div>
    </div>
  );
}
